import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M23.478 19.166c-.49 0-.957.098-1.39.254a4.257 4.257 0 0 0 .396-1.745c0-2.484-2.484-4.347-2.484-4.347s-2.484 1.863-2.484 4.347c0 .628.159 1.216.396 1.745a4.1 4.1 0 0 0-1.39-.254c-2.485 0-4.348 2.485-4.348 2.485s1.863 2.484 4.348 2.484c1.457 0 2.699-.854 3.478-1.56.78.706 2.022 1.56 3.478 1.56 2.485 0 4.348-2.485 4.348-2.485s-1.863-2.484-4.348-2.484Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m20 7.826.513 1.58h1.66l-1.342.976.512 1.58L20 10.984l-1.343.976.512-1.58-1.343-.976h1.66L20 7.826Zm-6.315 2.762.987.89 1.15-.665-.54 1.214.988.889-1.322-.139-.54 1.214-.276-1.3-1.321-.139 1.15-.664-.276-1.3Zm-4.623 4.623 1.3.277.664-1.15.139 1.32 1.3.277-1.214.54.139 1.321-.89-.987-1.213.54.664-1.15-.889-.988Zm17.253-4.623-.987.89-1.15-.665.54 1.214-.988.889 1.322-.139.54 1.214.276-1.3 1.322-.139-1.151-.664.276-1.3Zm4.623 4.623-1.3.277-.664-1.15-.139 1.32-1.3.277 1.215.54-.14 1.321.89-.987 1.213.54-.664-1.15.889-.988Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 31.092a8.655 8.655 0 0 0 5.252-1.767H14.748A8.655 8.655 0 0 0 20 31.092Zm-7.971-5.218a8.692 8.692 0 0 0 1.037 1.767h13.868a8.69 8.69 0 0 0 1.037-1.767H12.03Z"
}, null, -1), h = [
  c,
  n,
  s,
  a
];
function d(i, _) {
  return e(), l("svg", o, [...h]);
}
const r = { render: d };
export {
  r as default,
  d as render
};
